import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { DocumentUploadContext } from "@shared-kernel/application/ports/shared/document-upload-provider";

type UploadImagePayload = DocumentUploadContext & { image: File };

export const uploadImage = createAsyncThunk<string, UploadImagePayload, { extra: Partial<Dependencies> }>(
  "images/uploadImage",
  async (payload, { extra: { documentUploadProvider } }) => {
    const { image, ...context } = payload;
    return documentUploadProvider!.uploadImage(image, context);
  },
);

export const resetUploadImage = createAction("images/resetUploadImage");
